import QuestionnaireCompletedContainer from './questionnaire_completed_container';

const QuestionnaireCompleted = QuestionnaireCompletedContainer;
export default QuestionnaireCompleted;
